import {Component, Input, ViewEncapsulation} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {GeneralService} from "../../../../core/services/general.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {TableService} from "../../../../core/services/table.service";
import {VehicleService} from "../../../../core/services/vehicle.service";
import {TagInputModule} from "ngx-chips";

@Component({
  selector: 'app-new',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgForOf,
    NgClass,
    NgIf,
    TagInputModule
  ],
  templateUrl: './new.component.html',
  styleUrl: './new.component.scss'
})
export class NewComponent {
  @Input() data: any;
  public categoryCapacity: any = [];
  public categoryVehicleForm: FormGroup;
  public validate: boolean = false;
  public capacitiesArray = [];

  constructor(private fb: FormBuilder,private generalService: GeneralService, public modal: NgbModal, private tableService: TableService,private vehicleService:VehicleService) {
    this.categoryVehicleForm = this.fb.group({
      id: [0],
      description: ["", Validators.required],
      image:[""],
      image_url: [""],
      comfort: ["", Validators.required],
      security: ["", Validators.required],
      vehicles_description: [""],
      capacityForm: this.fb.array<FormGroup>([])
    })
  }

  ngOnInit(): void {
    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"CapacityVehicleCategory",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {
      this.categoryCapacity = value;
      this.createFormCapacity(value);
    });

    if(this.data["category_vehicle.id"]) {
      this.categoryVehicleForm.patchValue({
        id: this.data["category_vehicle.id"],
        description:this.data["category_vehicle.description"],
        image_url:this.data["category_vehicle.image"],
        comfort:this.data["category_vehicle.comfort"],
        security:this.data["category_vehicle.security"],
        vehicles_description:this.data["category_vehicle.vehicles_description"],
      });
      this.loadCapacity(this.data["category_vehicle.id"]);
    }
  }

  createFormCapacity(capacities: any[]) {
    const formArray = this.fb.array<FormGroup>([]);
    capacities.forEach(cap => {
      const input = this.fb.group({
        type_id:[cap.id],
        quantity:[''],
        id:['']
      });
      formArray.push(input);
    });
    this.categoryVehicleForm.setControl('capacityForm', formArray);
  }

  add() {
    let methode = 'add';
    if (this.categoryVehicleForm.invalid) {
      this.validate = true;
    } else {
      this.vehicleService.actionsVehicleCategory(this.categoryVehicleForm.value,methode).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
            }
          },
          (err) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    }
  }

  loadList(config: any, setVariable: (value: any) => void):void {
    this.tableService.loadSelectOptions(config).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            setVariable([]);
          } else {
            setVariable(res['message']);
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          setVariable([]);
        }
    );
  }

  loadCapacity(idCategory:any) {
    let methode = 'getcategorycapacity';
    this.vehicleService.actionsVehicleCategory(idCategory,methode).subscribe(
      (res: any) => {
        if (res.error) {
          //this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
        } else {
          this.capacitiesArray = res.message;
          this.capacitiesArray.forEach((cap) => {
            const index = this.capacityForm.controls.findIndex(ctrl => ctrl.get('type_id')?.value == cap["type_id"]);
            if(index !== -1) {
              this.capacityForm.at(index).patchValue({
                quantity:cap["quantity"],
                id:cap['id']
              });
            }
          });
        }
      },
      (err) => {
        //this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
      }
    );
  }

  get capacityForm(): FormArray<FormGroup> {
    return this.categoryVehicleForm.get('capacityForm') as FormArray<FormGroup>;
  }
  get descriptionValidate() {
    return this.categoryVehicleForm.get("description");
  }

  get imagenUrl(): string {
    return this.categoryVehicleForm.get('image_url')?.value;
  }
  get comfortValidate() {
    return this.categoryVehicleForm.get("comfort");
  }
  /*get securityValidate() {
    return this.categoryVehicleForm.get("security");
  }
  get vehiclesValidate() {
    return this.categoryVehicleForm.get("vehicles_description");
  }*/

}
